export const capitalizeFirstLetter = (message: string): string =>
  message.charAt(0).toUpperCase() + message.slice(1);

export const capitalizeWord = (message: string): string =>
  message.charAt(0).toUpperCase() + message.slice(1).toLowerCase();

export const capitalizeAll = (message: string): string =>
  message.split(' ').map(capitalizeWord).join(' ');

export const getSpaceSizeString = (sizeInMB: number): string => {
  return sizeInMB > 1024
    ? `${Math.ceil(sizeInMB / 1024)}GB`
    : `${sizeInMB.toFixed(2)}MB`;
};
